const doc = [({"en":({"js":({"tenants":({"select":({"choose_tenant":"Choose tenant"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;